import React from "react";
import { NUMA_POSES } from "@/components/NumaLogo";

/**
 * The larger mascot, for empty states and moments where a little warmth is
 * welcome. Static by default: in a tool people write in for hours, a looping
 * animation in the periphery is noise, not personality.
 */
export default function NumaMascot({ size = 96, className = "", variant = 0, alt = "" }) {
  const src = NUMA_POSES[Math.abs(variant) % NUMA_POSES.length];
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      className={`object-contain select-none ${className}`}
      style={{ maxWidth: size, maxHeight: size }}
      draggable={false}
      onError={(e) => {
        e.currentTarget.style.visibility = "hidden";
      }}
    />
  );
}
